import { createAsyncThunk } from "@reduxjs/toolkit";
import { CustomAction } from "../../store/customAction";
import {
  API_GET_USER_LOGOUT,
  API_POST_LOGIN,
  API_POST_SENT_OTP,
  API_POST_VALIDATE_OTP,
} from "../../Apis/ApiEndPoints";
import { Api } from "../../";
import {
  ILoginRequestParmasWithLoginType,
  ILoginResponse,
  ILogoutRequestBody,
  ISendOtpRequestParmas,
  IVerifyOtpRequestParams,
} from "../../models/user/userAuth/userAuth";

export const login = createAsyncThunk(
  "userAuth/login",
  async (
    { requestParams, loginType }: ILoginRequestParmasWithLoginType,
    { dispatch }
  ) => {
    const response: ILoginResponse = await CustomAction(
      Api.post(`${API_POST_LOGIN}/${loginType}`, requestParams),
      dispatch,
      "userAuth/login"
    );

    return response;
  }
);

export const sendOtp = createAsyncThunk(
  "userAuth/sendOtp",
  async (requestParams: ISendOtpRequestParmas, { dispatch }) => {
    await CustomAction(
      Api.post(API_POST_SENT_OTP, requestParams),
      dispatch,
      "userAuth/sendOtp"
    );
  }
);

export const verifyOtp = createAsyncThunk(
  "userAuth/verifyOtp",
  async (requestParams: IVerifyOtpRequestParams, { dispatch }) => {
    const response = await CustomAction(
      Api.post(API_POST_VALIDATE_OTP, requestParams),
      dispatch,
      "userAuth/verifyOtp"
    );
    return response;
  }
);

export const logout = createAsyncThunk(
  "userAuth/logout",
  async (requestBody: ILogoutRequestBody, { dispatch }) => {
    await CustomAction(
      Api.get(API_GET_USER_LOGOUT, { params: requestBody }),
      dispatch,
      "userAuth/logout"
    );
  }
);
